<template>
    <span
        class="wrapper"
        :class="cssClass"
        :id="componentId"
    >
        <input
            :class="cssClass"
            ref="modelValue"
            :value="value"
            :placeholder="placeholder"
            @input="modelChange()"
            @click="clickOnInput()"
        >
        <ul
            class="suggestions list-unstyled"
            :id="suggestionListId"
            style="display: none;"
        >
            <li
                v-for="suggestion in filteredSuggestions"
                :key="suggestion"
                @click="selected(suggestion.value)"
            >
                <span>{{ suggestion.label }}</span>
            </li>
        </ul>
    </span>
</template>
<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Helper } from '@/utils';

@Component({})
export default class TypeaheadComponent extends Vue {
    private filteredSuggestions: any[] = [];
    private suggestionListId = '';
    private componentId = '';
    private listElement: any = null;
    private clickHandler: any = null;

    @Prop()
    private cssClass: any;

    @Prop()
    private placeholder: any;

    @Prop()
    private value: any;

    @Prop()
    private suggestions: any;

    constructor() {
        super();
    }

    mounted(): void {
        this.componentId = Helper.generateGUID(8);
        this.suggestionListId = Helper.generateGUID(8);
        this.clickHandler = (event: any): void => {
            this.listElement = document.getElementById(this.suggestionListId);
            if (!event.target.closest(`[id='${this.componentId}']`)) {
                this.showList(false);
            }
        };
        document.addEventListener('click', this.clickHandler);
    }

    beforeDestroy(): void {
        document.removeEventListener('click', this.clickHandler);
    }

    private modelChange(): void {
        const ref = (this.$refs.modelValue as any);
        if (ref) {
            this.filteredSuggestions = [];
            if (ref.value.length > 2) {
                this.filteredSuggestions = this.suggestions.filter((s: any) => s.value.indexOf(ref.value) > -1);
            }
            const show = this.filteredSuggestions.length > 0;
            this.showList(show);
            this.$emit('input', ref.value);
            this.$emit('change', ref.value);
        }
    }

    private selected(val: string): void {
        this.filteredSuggestions = [];
        this.$emit('input', val);
        this.$emit('change', val);
        this.showList(false);
    }

    private clickOnInput(): void {
        if (this.filteredSuggestions.length > 1) {
            this.showList(true);
        }
    }

    private showList(val: boolean): void {
        this.listElement.style = `display: ${val === true ? 'block' : 'none'};`;
    }
}
</script>

<style lang="less" >
span.wrapper {
    position: relative;
    flex: 1 1 auto;
    display: inline-block;
    padding: 0 !important;
    border: none !important;
    input {
        width: 100% !important;
        border-radius: 0;
    }
    .suggestions {
        position: fixed;
        width: 200px;
        margin-top: 2px;
        max-height: 300px;
        overflow-y: auto;
        background: #fff;
        border: 1px solid #bcbcbc;
        box-shadow: 3px 2px 3px rgba(0, 0, 0, 0.2);
        z-index: 10;
        font-size: 16px;
        li {
            padding: 5px 10px;
            &:hover {
                cursor: pointer;
                background: #efefef;
                transition: 0.2s ease-in;
            }
        }
    }
}

</style>
